class CartScrollableContent extends CustomElement {}

customElements.define("cart-scrollable-content", CartScrollableContent);

class CartIconBubble extends CustomButton {
  onLoad(isLoading) {
    super.onLoad(isLoading);

    this.disabled = !!isLoading;
  }

  onDisabledChange(isDisabled) {
    this.$el[!!isDisabled ? "addClass" : "removeClass"]("is-disabled");
  }
}

customElements.define("cart-icon-bubble", CartIconBubble);

class CartDrawer extends CustomElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  get refs() {
    return {
      scrollableContent: this.$el.find("cart-scrollable-content").get(0),
      cartItems: this.querySelector("cart-drawer-items"),
      cartUpsell: this.querySelector("cart-upsell"),
      cartIconBubble: document.getElementById("cart-icon-bubble"),
    };
  }

  async mounted() {}

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = url;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async open(triggeredBy) {
    if (!window.isCartDrawerLoaded) {
      this.loadScript(window.cartDrawerScriptUrl).then(async () => {
        window.isCartDrawerLoaded = true;
        await this.sleep(1000);
        this.querySelector("#CartDrawer-Loading").style.display = "none";
        this.querySelector("#CartDrawer-Content").style.display = "grid";
        this.querySelector("#CartDrawer-Summary").style.display = "block";
      });
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add("animate", "active");
      this.querySelector(".drawer").classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("no-scroll");
  }

  close() {
    this.classList.remove("active");
    this.querySelector(".drawer").classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("no-scroll");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);

      sectionElement.outerHTML = this.getSectionOuterHTML(
        parsedState.sections[section.section],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionOuterHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).outerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "CartDrawerItems",
        section: "cart-drawer-items",
        selector: "#CartDrawer-CartItems",
      },
      {
        id: "shopify-section-cart-drawer-summary",
        section: "cart-drawer-summary",
        selector: ".cart-drawer-summary-wrapper",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-icon-bubble",
      },
      {
        id: "shopify-section-cart-drawer-upsell",
        section: "cart-drawer-upsell",
      },
      {
        id: "shopify-section-cart-drawer-upsell-before-checkout",
        section: "cart-drawer-upsell-before-checkout",
        selector: ".cart-drawer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onLoad(isLoading) {
    this.$el[!!isLoading ? "addClass" : "removeClass"]("is-loading");
  }
}

customElements.define("cart-drawer", CartDrawer);
